module.exports = __webpack_public_path__ + "static/media/availability-slide-1.96ebe6c4.jpg";